import axios, {AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { API_URL , ErrorResponse, TaskResponse} from "../constant";
import { constants } from "buffer";

export async function api_bulkemail(formData: FormData): Promise<TaskResponse> {

    try {
        const token = localStorage.getItem("token")
        
        const response = await axios.post(
          `${API_URL}api/user/bulkemail`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            validateStatus: (status) => {
                return status >= 200 && status < 500;
            },
          }
        );
        if (response.status === 200)
        {
            return { success: true, taskid: response.data.taskid, progress: response.data.progress, errorMsg: "" };
        }
        else{
            return { success: true, taskid: null, progress: 0, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: true, taskid: null, progress: 0, errorMsg:`"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: true, taskid: null, progress: 0, errorMsg:"No response received from server" };
        } else {
            return { success: true, taskid: null, progress: 0, errorMsg:`Error:, ${error.message}` };
        }
    }
}

export async function api_active_task(): Promise<TaskResponse> {

    try {
        const token = localStorage.getItem("token")

        const response = await axios.get(
            `${API_URL}api/user/getactivetask`, {
            validateStatus: (status) => status >= 200 && status < 500,
            headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 200)
        {
            //console.log(response.data);
            return { success: true, taskid: response.data.taskid, progress: response.data.progress, errorMsg: "" };
        }
        else{
            return { success: true, taskid: null, progress: 0, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: true, taskid: null, progress: 0, errorMsg:`"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: true, taskid: null, progress: 0, errorMsg:"No response received from server" };
        } else {
            return { success: true, taskid: null, progress: 0, errorMsg:`Error:, ${error.message}` };
        }
    }
}

export async function api_stop_send(): Promise<ErrorResponse> {

    try {
        const token = localStorage.getItem("token")

        const response = await axios.get(
            `${API_URL}api/user/stopsendmail`, {
            validateStatus: (status) => status >= 200 && status < 500,
            headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 204)
        {
            //console.log(response.data);
            return { success: true, errorMsg: "Success to stop sending emails" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg:`"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg:"No response received from server" };
        } else {
            return { success: false, errorMsg:`Error:, ${error.message}` };
        }
    }
}